/**
 * Cart Pairing System
 * Links madetoorder products with their lab grown diamonds using unique pair IDs
 */

(function() {
  let awaitingPair = null;
  let pairTimeout = null;

  function generatePairId() {
    return `pair_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
  }

  function isMadeToOrderProduct() {
    // Check for stone marketplace or madetoorder indicators
    const hasStoneMarketplace = document.querySelector('[data-stone-marketplace]') ||
                                 document.querySelector('.stone-marketplace') ||
                                 document.querySelector('[id*="stone-marketplace"]');
    const hasMadeToOrderTag = document.body.innerHTML.toLowerCase().includes('madetoorder');

    return hasStoneMarketplace || hasMadeToOrderTag;
  }

  function addPairIdToJson(body, pairId) {
    try {
      const data = JSON.parse(body);

      if (data.items && Array.isArray(data.items)) {
        data.items = data.items.map(item => ({
          ...item,
          properties: { ...(item.properties || {}), _pair_id: pairId }
        }));
      } else {
        data.properties = { ...(data.properties || {}), _pair_id: pairId };
      }

      return JSON.stringify(data);
    } catch (e) {
      return body;
    }
  }

  // Intercept fetch requests
  const originalFetch = window.fetch;
  window.fetch = function(url, options = {}) {
    if (url && typeof url === 'string' && url.includes('cart/add') && isMadeToOrderProduct()) {
      let pairId;

      // Use existing pair ID if within 5 seconds, otherwise generate new one
      if (awaitingPair && (Date.now() - awaitingPair.timestamp < 5000)) {
        pairId = awaitingPair.pairId;
        awaitingPair = null;
        if (pairTimeout) clearTimeout(pairTimeout);
      } else {
        pairId = generatePairId();
        awaitingPair = { pairId, timestamp: Date.now() };
        pairTimeout = setTimeout(() => { awaitingPair = null; }, 5000);
      }

      const modifiedOptions = { ...options };

      if (modifiedOptions.body instanceof FormData) {
        const newFormData = new FormData();
        for (let [key, value] of modifiedOptions.body.entries()) {
          newFormData.append(key, value);
        }
        newFormData.append('properties[_pair_id]', pairId);
        modifiedOptions.body = newFormData;
      } else if (typeof modifiedOptions.body === 'string') {
        modifiedOptions.body = addPairIdToJson(modifiedOptions.body, pairId);
      }

      return originalFetch.call(this, url, modifiedOptions);
    }

    return originalFetch.call(this, url, options);
  };
})();
